import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 30px;
  min-height: 164px;
  background-image: url('/images/clouds.svg');
  background-position: -3px 92px;
  background-repeat: repeat-x, no-repeat, no-repeat, no-repeat;
  background-color: ${({ theme }) => theme.travelReaquested.headerBackground};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  background-color: ${ColorPalette.HEX.White};
  border-radius: 100%;
  cursor: pointer;
`;

export const Logo = styled.img`
  height: 43px;
`;
